import './assets/typography.css';const s = {
  "work-sans-heading-40": "_work-sans-heading-40_1sg24_2",
  "work-sans-heading-32": "_work-sans-heading-32_1sg24_12",
  "work-sans-heading-28": "_work-sans-heading-28_1sg24_22",
  "work-sans-heading-24": "_work-sans-heading-24_1sg24_32",
  "work-sans-heading-20": "_work-sans-heading-20_1sg24_42",
  "work-sans-heading-16": "_work-sans-heading-16_1sg24_52",
  "work-sans-20-regular": "_work-sans-20-regular_1sg24_62",
  "work-sans-20-medium": "_work-sans-20-medium_1sg24_73",
  "work-sans-16-regular": "_work-sans-16-regular_1sg24_84",
  "work-sans-16-medium": "_work-sans-16-medium_1sg24_95",
  "work-sans-16-semi-bold": "_work-sans-16-semi-bold_1sg24_106",
  "work-sans-14-regular": "_work-sans-14-regular_1sg24_117",
  "work-sans-14-medium": "_work-sans-14-medium_1sg24_128",
  "work-sans-14-semi-bold": "_work-sans-14-semi-bold_1sg24_139",
  "work-sans-13-medium": "_work-sans-13-medium_1sg24_150",
  "work-sans-13-semi-bold": "_work-sans-13-semi-bold_1sg24_161",
  "work-sans-12-regular": "_work-sans-12-regular_1sg24_172",
  "work-sans-text-xs--regular-trimmed": "_work-sans-text-xs--regular-trimmed_1sg24_183",
  "work-sans-12-medium": "_work-sans-12-medium_1sg24_196",
  "work-sans-12-semi-bold": "_work-sans-12-semi-bold_1sg24_207",
  "work-sans-uppercase-14-regular": "_work-sans-uppercase-14-regular_1sg24_218",
  "work-sans-uppercase-14-medium": "_work-sans-uppercase-14-medium_1sg24_229",
  "work-sans-uppercase-12-medium": "_work-sans-uppercase-12-medium_1sg24_240",
  "work-sans-uppercase-12-semi-bold": "_work-sans-uppercase-12-semi-bold_1sg24_251",
  "work-sans-uppercase-9-semi-bold": "_work-sans-uppercase-9-semi-bold_1sg24_262",
  "nkduy-mono-numerical-32-medium": "_nkduy-mono-numerical-32-medium_1sg24_273",
  "nkduy-mono-numerical-24-regular": "_nkduy-mono-numerical-24-regular_1sg24_284",
  "nkduy-mono-numerical-20-regular": "_nkduy-mono-numerical-20-regular_1sg24_295",
  "nkduy-mono-numerical-16-regular": "_nkduy-mono-numerical-16-regular_1sg24_306",
  "nkduy-mono-numerical-16-medium": "_nkduy-mono-numerical-16-medium_1sg24_318",
  "nkduy-mono-numerical-16-bold": "_nkduy-mono-numerical-16-bold_1sg24_329",
  "nkduy-mono-numerical-14-medium": "_nkduy-mono-numerical-14-medium_1sg24_340",
  "nkduy-mono-numerical-14-semi-bold": "_nkduy-mono-numerical-14-semi-bold_1sg24_351",
  "nkduy-mono-numerical-14-bold": "_nkduy-mono-numerical-14-bold_1sg24_362",
  "nkduy-mono-numerical-13-medium": "_nkduy-mono-numerical-13-medium_1sg24_373",
  "nkduy-mono-numerical-13-semi-bold": "_nkduy-mono-numerical-13-semi-bold_1sg24_385",
  "nkduy-mono-numerical-sm--semi-bold-trimmed": "_nkduy-mono-numerical-sm--semi-bold-trimmed_1sg24_396",
  "nkduy-mono-numerical-13-bold": "_nkduy-mono-numerical-13-bold_1sg24_409",
  "nkduy-mono-numerical-12-semi-bold": "_nkduy-mono-numerical-12-semi-bold_1sg24_420",
  "nkduy-mono-numerical-12-bold": "_nkduy-mono-numerical-12-bold_1sg24_431",
  "work-sans-10-regular": "_work-sans-10-regular_1sg24_442",
  "work-sans-10-medium": "_work-sans-10-medium_1sg24_451",
  "nkduy-mono-numerical-10-bold": "_nkduy-mono-numerical-10-bold_1sg24_460"
};
export {
  s
};
